import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import noimage from "../../../assets/icons/productoNoDisponible.svg"; //'postobon.png'
import botella from "../../../assets/icons/botella-mas.svg";
import * as constant from "../../../global/const";
import { Redemption } from "../Redencion/Redemption.page";
import { Alerta } from "../../Cabezote/alerta.component";

export const RepositionCardProduct = ({ producto, handleDeleteToCart }) => {
  const [showModalRedemption, setShowModalRedemption] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [codigoSku, setCodigoSku] = useState(producto.key.replace("-", "")); //useState(producto.codigoSkuPromocion);

  const editarRedencion = () => {
    setShowModalRedemption(true);
  };

  return (
    <div className="item-carrito">
      {showModalRedemption && (
        <Redemption
          codigoSku={codigoSku}
          setShowModalRedemption={setShowModalRedemption}
        />
      )}
      <div className="icons delete">
        <i
          className="far fa-times-circle"
          style={{ cursor: "pointer" }}
          onClick={() => handleDeleteToCart(producto)}
        ></i>
      </div>
      <img
        className="img-product"
        src={
          constant.URL_BASE_IMAGES +
          "image/" +
          producto.codigoSkuPromocion +
          ".jpg?" +
          Math.random()
        }
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noimage;
        }}
        alt="First slide"
      />
      <div className="item">
        <p className="spacing">{producto.nombre}</p>
        <div className="contenedor-item-box">
          <div className="item-box">
            <img src={botella} alt="Not found" />
            <p>Tienes unidades en obsequio de este producto</p>
          </div>
        </div>
      </div>
      <div className="item-info">
        <div class="inline">
          <h2>
            <span>{producto.cantidadTotal}</span> Unidades
          </h2>
        </div>
        <div class="inline">
          <a onClick={() => editarRedencion()}>Editar</a>
        </div>

        {/**<p>Unidade(s)</p>*/}
      </div>
    </div>
  );
};
